import type { Route } from 'vue-router';
import { DEFAULT_QUERY_VALUES, QUERY_KEY } from '~~/constants/typesense';
import { getFirstChildOrSelf } from '~~/helpers/dataStructure/getFirstChildOrSelf';

export const getHitsPerPageConfiguration = (query: Route['query']): number => {

  const hitsPerPageQuery: string = getFirstChildOrSelf(query[`${QUERY_KEY.HITS_PER_PAGE}`])?.toString();

  return hitsPerPageQuery ? parseInt(hitsPerPageQuery) : DEFAULT_QUERY_VALUES[QUERY_KEY.HITS_PER_PAGE];

};
